/* eslint-disable max-len */
import React, { useEffect, useState, useContext } from 'react';
import CardHeader from "../../../../components/CardHeader"
import EmptyAddScreen from '../../../../components/EmptyAddScreen';
import { Link, useSearchParams } from 'react-router-dom';
import DropDownComponent from './Components/DropDownComponent';
import { dataService } from '../../../../services/data.services';
import Table from './Components/Table'
import Shimmer from '../../../../components/Shimmer/itemShimmer'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen';
import GlobalContext from '../../../../components/Context/GloablContext';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import Loader from '../../../../components/Loader';
import Toast from '../../../../components/Toast';

const PromoteHistory = () => {
    const {setToastmessage, isInactiveBranch} = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1})
    const [academicYearsDropdownPlaceholder,setAcademicYearsDropdownPlaceholder] =useState('Select AY')
    const [academicYearsDropdownValue,setAcademicYearsDropdownValue] =useState('')
    const [academicYearsDropdownTitle,setAcademicYearsDropdownTitle] =useState('')
    const [academicYearsDropdownOptions,setAcademicYearsDropdownOptions] =useState({})
    const [promotedStudentsList, setPromotedStudentList] = useState([])
    const [promotedStudentsCount, setPromotedStudentCount] = useState(0)
    const [promotedStudentsAcrossAllAYCount, setPromotedStudentsAcrossAllAYCount] = useState(0)
    const [pageLoading, setPageLoading] = useState(true)
    const [exportBtnLoading, setExportBtnLoading] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState("")

    const arrayToMap = Array.isArray(academicYearsDropdownOptions)
        ? academicYearsDropdownOptions
        : [academicYearsDropdownOptions];

    /**
     * The function `updateNameWithStatus` takes an array of objects, and for each object, it adds the
     * status to the name property in the format "(Status)".
     * @returns an updated array where each item's name is modified to include the status in parentheses.
     */
    function updateNameWithStatus(array) {
        return array?.map(item => {
            return {
                ...item,
                name: `${item.name} (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`,
                title: `${item.name} (${new Date(item.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${new Date(item.end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' })}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`
            };
        });
    }
    
    /* The line `const updatedAcademicYearsDropdownOptions = updateNameWithStatus(arrayToMap);` is calling
    the `updateNameWithStatus` function and passing `arrayToMap` as an argument. */
    const updatedAcademicYearsDropdownOptions = updateNameWithStatus(arrayToMap);

    /**
     * The function `handleAcademicYearDropdown` sets the value of the academic year dropdown and makes an
     * API call to get promoted students based on the selected academic year.
     */
    const handleAcademicYearDropdown = (id, item, index) => {
        getPromotedStudentsAPICall(item?._id)
        let newSearchParams = Object.fromEntries(searchParams);
        newSearchParams.ay = item?.name
        newSearchParams.ay_id = item?._id
        newSearchParams.page_number = 1
        setSearchParams(newSearchParams)
        setAcademicYearsDropdownValue(item?.name)
        setAcademicYearsDropdownTitle(`${item?.name} (${new Date(item?.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${new Date(item?.end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' })})`)
    }

    const exportBtnhandler = () => {
        if (pageLoading || exportBtnLoading) {
            return;
        }
        if (promotedStudentsCount === 0) {
            setToastErrorMessage("No records to export");
            return;
        }
        getExportDataForPromotedStudentsAPICall()
    }

    /**
     * The function `getAcademicYearsAPICall` makes an API call to retrieve academic years data, sets the
     * dropdown options for academic years, sets the placeholder and value for the dropdown, and makes
     * another API call to retrieve promoted students data.
     */
    const getAcademicYearsAPICall = async() => {
        try{
            setPageLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,completed`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp = response?.data?.data?.data
            setAcademicYearsDropdownOptions(temp)
            console.log(response)
            console.log(response?.data?.data)
            console.log(response?.data?.data?.data)
            if(response?.data?.data?.data?.length === 0){
                setPageLoading(false)
                return
            }
            const ongoingObjects = temp.filter(obj => obj.status === "ongoing");
            // Sort by created_at in ascending order 
            // Doing this in case there are more then one ongoing AY
            ongoingObjects.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            if (searchParams?.get('ay') === null){
                if (ongoingObjects?.length > 0) {
                    setAcademicYearsDropdownPlaceholder(ongoingObjects[0].name)
                    setAcademicYearsDropdownValue(`${ongoingObjects[0].name} (${ongoingObjects[0].status.charAt(0).toUpperCase() + ongoingObjects[0].status.slice(1)})`)
                    setAcademicYearsDropdownTitle(`${ongoingObjects[0].name} (${new Date(ongoingObjects[0].start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${new Date(ongoingObjects[0].end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' })}) (${ongoingObjects[0].status.charAt(0).toUpperCase() + ongoingObjects[0].status.slice(1)})`)                
                } else {
                    setAcademicYearsDropdownPlaceholder('Select AY')
                }
                getPromotedStudentsAPICall(ongoingObjects[0]._id)
            } else {
                setAcademicYearsDropdownPlaceholder(searchParams.get('ay').split('(')[0].trim())
                setAcademicYearsDropdownValue(searchParams.get('ay'))
                setAcademicYearsDropdownTitle(`${searchParams.get('ay')} (${new Date(ongoingObjects[0].start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${new Date(ongoingObjects[0].end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' })})`)
                getPromotedStudentsAPICall(searchParams.get('ay_id'))
            }
        } catch (error){
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }

    /**
     * The function `getPromotedStudentsAPICall` makes an API call to retrieve a list of promoted students
     * based on the provided academic year.
     */
    const getPromotedStudentsAPICall = async(academicYearIDForAPI) => {
        try{
            setPageLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `promote-students?branch_id=${branch_id}&limit=10&page_number=${searchParams.get('page_number')===null ? '1' : searchParams.get('page_number')}&filter=true&academic_year_id=${academicYearIDForAPI}`;
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.all_total_count
            setPromotedStudentList(temp)
            setPromotedStudentCount(temp2)
            setPromotedStudentsAcrossAllAYCount(temp3)
        } catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setPageLoading(false)
        }
    }

    /**
     * The function `getExportDataForPromotedStudentsAPICall` makes an API call to retrieve data for
     * promoted students and opens a new window with the pre-signed URL for exporting the data.
     */
    const getExportDataForPromotedStudentsAPICall = async() => {
        try{
            setExportBtnLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `promote-students?branch_id=${branch_id}&filter=true&academic_year=${academicYearsDropdownValue.split('(')[0].trim()}&export=true`;
            const response = await dataService.GetAPI(endpoint)
            setToastmessage(response?.data?.data?.message)
            window.open(response?.data?.data?.pre_signed_url)
        } catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            setExportBtnLoading(false)
        } finally {
            setExportBtnLoading(false)
        }
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
    `useEffect` hook is used to make an API call to fetch academic years when the `searchParams`
    dependency changes. */
    useEffect(()=>{
        getAcademicYearsAPICall()
    },[])

    return <CardHeader noPadding >
        {/* Top Bar */}
        <div
            className="mainDataCntnrTop shadow-s13"
            style={{ position: "sticky", position: "-webkit-sticky"}}
        >
            <div className="flex">
                <h5 class=" pageHeader adderror">
                    Promote History
                </h5>
            </div> 
            {<div className="flex items-center">
                <div class="mr-2 flex items-center">
                    <p className="text-[#031624] text-[.9375rem] leading-6 pr-[10px]">Current Class AY </p>
                    <DropDownComponent
                        dropDownName={"AcademicYear"}
                        id={"AcademicYear"}
                        title={academicYearsDropdownTitle}
                        test_id={"AcademicYear"}
                        divClassName={`relative w-[235px] z-40`}
                        value={academicYearsDropdownValue}
                        placeHolder={academicYearsDropdownPlaceholder}
                        buttonDisabled={false}
                        options={updatedAcademicYearsDropdownOptions}
                        handleOnchangeInput={handleAcademicYearDropdown}
                        tooltip={true} />
                </div>
                {!isInactiveBranch && <Link to='/student-master/promote-history/promote-students' 
                    className="prmy-btn">
                    Promote
                </Link>}
                {/* <button onClick={exportBtnhandler} id='export'
                    className={`prmy-btn`}>
                    {exportBtnLoading ? <Loader /> : 'Export'}
                </button>  */}
            </div>}
            {toastErrorMessage !== "" && (
                <Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage}
                />
            )}
        </div>
        {/* Listing */}
        <div class="mainDataCntnrListDiv">
            {pageLoading ?
                <div className=''><Shimmer /> </div>
                :
                <>
                    <Table promotedStudentsList={promotedStudentsList} setPageLoading={setPageLoading} searchParams={searchParams}
                        setSearchParams={setSearchParams} promotedStudentsCount={promotedStudentsCount}
                    />

                </>
            }
        </div>
    </CardHeader>
}

export default PromoteHistory;